export default "__VITE_ASSET__B5bR70Nv__"